/* Keyboard input keycode definitions */
export var KEY_TAB = 9;
export var KEY_ENTER = 13;
export var KEY_ESCAPE = 27;
// Arrow keys
export var KEY_ARROW_UP = 38;
export var KEY_ARROW_DOWN = 40;
export var KEY_ARROW_LEFT = 37;
export var KEY_ARROW_RIGHT = 39;
// Page keys
export var KEY_PAGE_UP = 33;
export var KEY_PAGE_DOWN = 34;
// Numbers
export var KEY_NR_0 = 48;
export var KEY_NR_1 = 49;
export var KEY_NR_9 = 57;
// helper functions
export var containsKey = function (keycode, inputsKeys) {
    var hasKey = false;
    if (inputsKeys && inputsKeys.length > 0) {
        ;
        [].forEach.call(inputsKeys, function (inputsKey) {
            if (keycode === inputsKey) {
                hasKey = true;
            }
        });
    }
    return hasKey;
};
export var getKeyValue = function (keycode) {
    if (keycode < 48 || keycode > 105) {
        return "";
    }
    return String.fromCharCode(96 <= keycode && keycode <= 105 ? keycode - 48 : keycode).toLowerCase();
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@swisscom/sdx/dist/es6/Inputs.js
// module id = 30
// module chunks = 0